// 9fbef606107a605d69c0edbcd8029e5d
/**
 * These are temporary changes for a dummy Bag page
 */

import CARTPAGE_CONSTANTS from '../CartItemTile.constants';

export const removeCartItem = (payload) => {
  return {
    type: CARTPAGE_CONSTANTS.REMOVE_CART_ITEM,
    payload,
  };
};

export const removeCartItemComplete = () => {
  return {
    type: CARTPAGE_CONSTANTS.REMOVE_CART_ITEM_COMPLETE,
  };
};

export const openPickupModalWithValuesFromBag = (payload) => {
  return {
    payload,
    type: CARTPAGE_CONSTANTS.PICKUP_MODAL_OPEN_FROM_BAG,
  };
};

export const triggerPriceDropNotification = (payload) => {
  return {
    payload,
    type: CARTPAGE_CONSTANTS.PRICE_DROP_NOTIFICATION,
  };
};

export const confirmRemoveCartItem = (payload, afterHandler, price) => {
  return {
    type: CARTPAGE_CONSTANTS.CONFIRM_REMOVE_CART_ITEM,
    payload,
    afterHandler,
    price,
  };
};

export const getProductSKUInfo = (payload) => {
  return {
    type: CARTPAGE_CONSTANTS.GET_PRODUCT_SKU_INFO,
    payload,
  };
};

export const getProductSKUInfoSuccess = (payload) => {
  return {
    type: CARTPAGE_CONSTANTS.GET_PRODUCT_SKU_INFO_SUCCESS,
    payload,
  };
};

export const setProductMultiPackData = (payload) => {
  return {
    type: CARTPAGE_CONSTANTS.SET_PRODUCT_MULTIPACK_DATA,
    payload,
  };
};

export const updateCartItem = (payload) => {
  return {
    type: CARTPAGE_CONSTANTS.UPDATE_CART_ITEM,
    payload,
  };
};

export const updateStoreItem = (payload, enableModal) => {
  return {
    type: CARTPAGE_CONSTANTS.UPDATE_STORE_ITEM,
    payload,
    enableModal,
  };
};

export const updateCartItemComplete = () => {
  return {
    type: CARTPAGE_CONSTANTS.UPDATE_CART_ITEM_COMPLETE,
  };
};

export const setBossCartFromCheckout = (payload) => {
  return {
    type: CARTPAGE_CONSTANTS.SET_BOSS_CART_CHECKOUT,
    payload,
  };
};

export const setToggleCartItemError = (payload) => {
  return {
    type: CARTPAGE_CONSTANTS.SET_TOGGLE_CART_ITEM_ERROR,
    payload,
  };
};

export const setBossBopisToggleCartItemError = (payload) => {
  return {
    type: CARTPAGE_CONSTANTS.SET_TOGGLE_BOSS_BOPIS_CART_ITEM_ERROR,
    payload,
  };
};

export const clearToggleCartItemError = () => {
  return {
    type: CARTPAGE_CONSTANTS.CLEAR_TOGGLE_CART_ITEM_ERROR,
  };
};

export const clearToggleBossBopisCartItemError = () => {
  return {
    type: CARTPAGE_CONSTANTS.CLEAR_TOGGLE_BOSS_BOPIS_CART_ITEM_ERROR,
  };
};

export const setCartLoadingState = (payload) => {
  return {
    type: CARTPAGE_CONSTANTS.CART_LAODINGSTATE,
    payload,
  };
};
export const setApplePayCartLoadingState = (payload) => {
  return {
    type: CARTPAGE_CONSTANTS.ADYEN_APPLEPAY_CART_LAODINGSTATE,
    payload,
  };
};
export const setTileLoadingState = (payload) => {
  return {
    type: CARTPAGE_CONSTANTS.CART_TILE_LOADINGSTATE,
    payload,
  };
};
export const setStoreUpdatingState = (payload) => {
  return {
    type: CARTPAGE_CONSTANTS.STORE_UPDATING_STATE,
    payload,
  };
};

export const setStoreUpdateCompletedState = (payload) => {
  return {
    type: CARTPAGE_CONSTANTS.STORE_UPDATED_COMPLETED_STATE,
    payload,
  };
};

export const getShipmentProductInventoryData = (payload) => {
  return {
    type: CARTPAGE_CONSTANTS.SHIPMENT_PRODUCT_INVENTORY,
    payload,
  };
};

export const setShipmentProductInventoryDetails = (payload) => {
  return {
    type: CARTPAGE_CONSTANTS.SHIPMENT_PRODUCT_INVENTORY_DETAILS,
    payload,
  };
};

export const setCheckoutInProgress = (payload) => {
  return {
    type: CARTPAGE_CONSTANTS.CHECKOUT_IN_PROGRESS,
    payload,
  };
};

export const setBackPackAloneError = (payload) => {
  return {
    type: CARTPAGE_CONSTANTS.IS_BACKPACK_ALONE_ERROR,
    payload,
  };
};

export const scrollToTile = (payload) => {
  return {
    type: CARTPAGE_CONSTANTS.SCROLL_TO_TILE,
    payload,
  };
};

export const setBackPackOOSError = (payload) => {
  return {
    type: CARTPAGE_CONSTANTS.BACKPACK_OOS_ERROR,
    payload,
  };
};

export const backpackSFLCall = (payload) => {
  return {
    type: CARTPAGE_CONSTANTS.BACKPACK_SFL_CALL,
    payload,
  };
};

export const loadSocialProofCartData = (payload) => {
  return {
    type: CARTPAGE_CONSTANTS.LOAD_SOCIAL_PROOF_CART_DATA,
    payload,
  };
};
